export default [
  { value: 'America/Anchorage', label: 'Anchorage (Alaska)' },
  { value: 'America/Chicago', label: 'Chicago (Central)' },
  { value: 'America/Denver', label: 'Denver (Mountain)' },
  { value: 'US/Hawaii', label: 'Hawaii (HST)' },
  { value: 'America/Los_Angeles', label: 'Los Angeles (Pacific)' },
  { value: 'America/New_York', label: 'New York (Eastern)' },
  { value: 'America/Phoenix', label: 'Phoenix (MST)' },
  { value: 'America/Puerto_Rico', label: 'Puerto Rico (Atlantic)' },
];



// WEBPACK FOOTER //
// ./client/models/auth/timezones.js